import React, { Fragment } from 'react';
import {
  Alert,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
} from 'reactstrap';
import { isURL } from 'validator';
import { Link, withRouter } from 'react-router-dom';
import Card from '../../Card/Card';
import DomainUrl from '../DomainUrl';
import DomainDisclaimer from '../DomainDisclaimer';
import DomainTypes from '../DomainTypes';
import FlowOffers from '../../Flow/FlowOffers';
import FlowTDS from '../../Flow/FlowTDS';
import FlowLandingsTable from '../../Flow/FlowLandingsTable';
import AlertModal from '../../../modals/AlertModal/AlertModal';
import { FMessage } from '../../../hoc/IntlComponents';
import { FormattedMessage } from 'react-intl';
import DomainsTutorial from '../DomainsTutorial';
import DomainReplicaWarning from '../DomainReplicaWarning';

export default class DomainForm extends React.Component {
  render() {
    const {
      stateData,
      propsData,
      handleSubmit,
      handleDomainChange,
      getTypes,
      handleTypeChange,
      getOffersWithNoReplics,
      handleOfferChange,
      handleChange,
      handleTDSChange,
      getParkingType,
      handleLandingsChange,
      handlePrelandersChange,
      toggleModal,
      replicaOffersIds
    } = this.props;

    const { modal, errors, message } = stateData;
    const { type, domain, offerId, landings, prelanders, tdsId, title } = stateData.domain;
    const { isEdit, loading, offer, tdsStreams, profile } = propsData;
    const { site_key } = profile;
    return (
      <form onSubmit={handleSubmit}>
        <Card className="card-loading-silent" loading={loading}>
          <Card.Header>
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to="/tools/domains">
                  <FMessage id="domains.breadcrumb" />
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                {isEdit ? domain && domain.domain : <FMessage id="domain.title" />}
              </BreadcrumbItem>
            </Breadcrumb>
          </Card.Header>

          <Card.Body>
            <Row>
              <Col lg="6">
                <DomainTypes
                  type={type}
                  types={getTypes()}
                  onTypeChange={handleTypeChange}
                  disabled={isEdit}
                />
                <DomainUrl
                  message={message}
                  url={domain}
                  isEdit={isEdit}
                  onUrlChange={handleDomainChange}
                />
                {type !== 'tracking' && type !== 'tds' && (
                  <FlowOffers
                    offers={getOffersWithNoReplics()}
                    offerId={offerId}
                    onOfferChange={handleOfferChange}
                    error={errors.offer}
                    disabled={isEdit}
                  />
                )}
                {type === 'tds' && (
                  <Fragment>
                    <FormGroup className={errors.title ? 'has-error' : ''}>
                      <Label htmlFor="title">
                        <FormattedMessage id="flow.form.title" defaultMessage="Title" />
                      </Label>
                      <Input
                        id="title"
                        type="text"
                        name="title"
                        value={title}
                        onChange={handleChange}
                      />
                      {errors.title && <small className="form-text">{errors.title}</small>}
                    </FormGroup>

                    <FlowTDS
                      tdsStreams={tdsStreams}
                      tdsId={tdsId}
                      onTDSChange={handleTDSChange}
                      error={errors.tds}
                      disabled={isEdit}
                    />
                  </Fragment>
                )}
                {replicaOffersIds.length > 0 ? <DomainReplicaWarning /> : null}
              </Col>
              <Col>
                <DomainsTutorial type={type} parkingType={getParkingType()} />
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {offer && (
          <>
            {errors.landings && <Alert color="danger">{errors.landings}</Alert>}
            {errors.prelanders && <Alert color="danger">{errors.prelanders}</Alert>}

            {type === 'landing' && offer.landings && (
              <Card>
                <Card.Header>
                  <FormattedMessage id="flow.landings" defaultMessage="Landings" />
                </Card.Header>
                <Card.Body className="no-padding">
                  {offer.landings.length > 0 ? (
                    <FlowLandingsTable
                      name="landings"
                      landings={offer.landings}
                      checked={landings}
                      onLandingChange={handleLandingsChange}
                      showStreamCr={false}
                      multiple={false}
                      offerId={offer.id}
                      offer={offer}
                      site_key={site_key}
                      inDomain
                    />
                  ) : (
                    <div className="card-empty">
                      <FormattedMessage id="flow.no-landings" defaultMessage="No Landings" />
                    </div>
                  )}
                </Card.Body>
              </Card>
            )}

            {type === 'prelander' && offer.transits && (
              <Card>
                <Card.Header>
                  <FormattedMessage id="flow.prelanders" defaultMessage="Prelanders" />
                </Card.Header>
                <Card.Body className="no-padding">
                  {offer.transits.length > 0 ? (
                    <FlowLandingsTable
                      name="prelanders"
                      landings={offer.transits}
                      checked={prelanders}
                      onLandingChange={handlePrelandersChange}
                      showStreamCr={false}
                      multiple={false}
                      offerId={offer.id}
                      offer={offer}
                      site_key={site_key}
                      inDomain
                    />
                  ) : (
                    <div className="card-empty">
                      <FormattedMessage id="flow.no-prelanders" defaultMessage="No Prelanders" />
                    </div>
                  )}
                </Card.Body>
              </Card>
            )}
          </>
        )}
        <Row>
          <Col>
            <FormGroup>
              {isEdit ? (
                type === 'tracking' ? null : (
                  <Button color="primary" size="lg" disabled={!isURL(domain)}>
                    <FormattedMessage id="domain.form.save" defaultMessage="Save Domain" />
                  </Button>
                )
              ) : (
                <Button color="primary" size="lg" disabled={!isURL(domain)}>
                  <FormattedMessage id="domain.form.add" defaultMessage="Add Domain" />
                </Button>
              )}
            </FormGroup>
          </Col>
        </Row>

        {/* <AlertModal open={modal} message={message} onClose={this.toggleModal} /> */}
      </form>
    );
  }
}
